import { FC } from 'react'
import {
    Footer,
    RangeAndDate,
    Roller,
    Shape,
    Range,
    Sizes,
    SizesLength,
    SizesSeparator,
    SizesWidth,
    Space,
    Date,
} from './elements/elements'
import Stamp from '../../types/api/stamp'
import getTeeth from '../../helpers/fields-calculation/stamps/get-teeth'
import { formatRollerDisplay } from '../../helpers/format-roller-display'
import dayjs from 'dayjs'
import { outputDateFormat } from '../../constants/constants'

interface StampTubeLabelInfoProps {
    stamp: Stamp | null
}

const StampTubeLabelInfo: FC<StampTubeLabelInfoProps> = ({ stamp }) => {
    return (
        <>
            <Sizes>
                <SizesWidth>{stamp?.width}</SizesWidth>
                <SizesSeparator>x</SizesSeparator>
                <SizesLength>{stamp?.length}</SizesLength>
            </Sizes>
            <Shape>
                {stamp?.shape} ( {getTeeth(stamp?.roller)} )
            </Shape>
            <Space />
            <Footer>
                <Roller>Вал {formatRollerDisplay(stamp?.roller?.roller)}</Roller>
                <RangeAndDate>
                    <Range>между эт. {stamp?.range} мм</Range>
                    <Date>
                        {stamp?.createdAt ? dayjs(stamp?.createdAt).format(outputDateFormat) : ''}
                    </Date>
                </RangeAndDate>
            </Footer>
        </>
    )
}

export default StampTubeLabelInfo
